import {
  Box,
  Button,
  CardContent,
  Divider,
  Grid2 as Grid,
  Stack,
  Typography,
} from "@mui/material";
import { CardOutline } from "components/Card";
import { SmallLineChart } from "components/Charts";
import { FC } from "react";

export interface LineChartData {
  date: string;
  value: number;
  data?: any;
}

interface RequirementFeedbackStatsPanelProps {
  totalFeedbacks: number;
  currentRate: number;
  data: LineChartData[];
  onClickDot: (data: any) => void;
  onClickShowFeedbacks: () => void;
}

export const RequirementFeedbackStatsPanel: FC<
  RequirementFeedbackStatsPanelProps
> = ({
  totalFeedbacks,
  currentRate,
  data,
  onClickDot,
  onClickShowFeedbacks,
}) => {
  return (
    <Box>
      <Grid container spacing={2}>
        {/* Charts Section */}
        <Grid size={{ xs: 12, md: 6, lg: 8 }}>
          <CardOutline
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <Typography variant="body1" fontWeight={600} sx={{ mb: 2 }}>
                  Score Progress
                </Typography>
                <Box>
                  <Button
                    variant="text"
                    color="primary"
                    size="small"
                    onClick={onClickShowFeedbacks}
                  >
                    show feedbacks
                  </Button>
                </Box>
              </Stack>
              <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
                <SmallLineChart
                  data={data}
                  height={160}
                  onClickDot={onClickDot}
                />
              </Box>
            </CardContent>
          </CardOutline>
        </Grid>

        {/* Stats Section */}
        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <CardOutline
            sx={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            <CardContent
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Typography variant="body1" fontWeight={600} sx={{ mb: 1 }}>
                  Total Feedback
                </Typography>
                <Typography variant="h3" component="p" sx={{ mb: 3 }}>
                  {totalFeedbacks}
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Typography variant="body1" fontWeight={600} sx={{ mb: 1 }}>
                  Current Level
                </Typography>
                <Typography variant="h3" component="p">
                  {currentRate}
                </Typography>
              </Box>
            </CardContent>
          </CardOutline>
        </Grid>
      </Grid>
    </Box>
  );
};
